const DropZoneIconSize = Object.freeze({
  small: 'xs',
  large: 'sm'
});
export default DropZoneIconSize;